export default __webpack_public_path__ + "static/media/chart.4e51e02b.JPG";